module.exports = __webpack_public_path__ + "static/media/mars-3.438b9d86.jpg";